import { FilterTypeEnum } from '../../../enums';

import { ContextState, DateFilterSelectedValues, Filter, GetterClass, RegularFilterSelectedValues } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class AppliedFiltersCountGetter implements GetterClass {

  public static execute(state: ContextState, getters: any): number {
    return (Object.values(getters[CONTEXT_CONSTS.getters.enabledFilters])
      .reduce((appliedFiltersCount: number, filter: Filter) => {
        if (!filter.config.mandatory) {
          const hasSelectedValues = {
            [FilterTypeEnum.DATE]: () => (filter.selectedValues as DateFilterSelectedValues).some((value: number) => (value !== undefined)),
            [FilterTypeEnum.REALTIME]: () => (filter.selectedValues !== undefined),
            [FilterTypeEnum.REGULAR]: () => !!(filter.selectedValues as RegularFilterSelectedValues).length
          }[filter.config.type]();
          if (hasSelectedValues) {
            appliedFiltersCount++;
          }
        }
        return appliedFiltersCount;
      }, 0) as number);
  }

}
